import type { CountryCodes, Iso3166Alpha2Lower } from "../types/country-codes";

import { getCountryDefinition } from "./country-definitions";

function deriveCountryCodes(
  iso3166Alpha2Lower: Iso3166Alpha2Lower,
): CountryCodes {
  const countryDefinition = getCountryDefinition(iso3166Alpha2Lower);

  return {
    clientNoticeOfPrivacyPracticesPath:
      countryDefinition.clientNoticeOfPrivacyPracticesPath,
    defaultMapZoom: countryDefinition.defaultMapZoom,
    displayName: countryDefinition.displayName,
    geographicCenter: countryDefinition.geographicCenter,
    iso3166Alpha2: countryDefinition.iso3166Alpha2,
    iso3166Alpha2Lower: countryDefinition.iso3166Alpha2Lower,
    iso3166Alpha3: countryDefinition.iso3166Alpha3,
    iso3166Alpha3Lower: countryDefinition.iso3166Alpha3Lower,
    iso4217CurrencyCode: countryDefinition.iso4217CurrencyCode,
    locationSearchPlaceholder: countryDefinition.locationSearchPlaceholder,
    postalCodeFormatErrorMessage:
      countryDefinition.postalCodeFormatErrorMessage,
    postalCodeRequiredErrorMessage:
      countryDefinition.postalCodeRequiredErrorMessage,
    postalLocationRequiredErrorMessage:
      countryDefinition.postalLocationRequiredErrorMessage,
    privacyPolicyPath: countryDefinition.privacyPolicyPath,
    whatsNextToolkitUrl: countryDefinition.whatsNextToolkitUrl,
  };
}

export { deriveCountryCodes };
